import { forwardRef, type HTMLAttributes } from 'react'
import { cn } from '@/helpers/utils'

export const Overlay = forwardRef<
	HTMLDivElement,
	HTMLAttributes<HTMLDivElement> & { $type?: 'light' | 'dark' }
>(({ $type, className, ...props }, ref) => (
	<div
		className={cn(
			'fixed inset-0 z-(--z-modal-overlay)',
			$type === 'light' ? 'bg-neutral-white/80' : 'bg-neutral-black/40',
			className
		)}
		ref={ref}
		{...props}
	/>
))

Overlay.displayName = 'Overlay'
